export default function(value) {
  const days = Math.floor(value / (24 * 60 * 60));
  const hours = Math.floor((value - (days * 24 * 60 * 60)) / (60 * 60));
  const minutes = Math.ceil((value - (days * 60 * 60 * 24) - (hours * 60 * 60)) / (60));

  return `${days}d ${hours}h ${minutes}m`;
}
